/* EVIE theme interactions */
(function(){
  function reveal(){
    var els=[].slice.call(document.querySelectorAll('[data-reveal]'));
    var vh=window.innerHeight||document.documentElement.clientHeight;
    function show(e){e.classList.add('in');}
    function inView(e){var r=e.getBoundingClientRect();return r.top<vh*0.95&&r.bottom>0;}
    // Reveal anything already on-screen immediately (prevents hidden content on load)
    els.forEach(function(e){if(inView(e))show(e);});
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){
        es.forEach(function(e){if(e.isIntersecting){show(e.target);io.unobserve(e.target);}});
      },{threshold:0,rootMargin:'0px 0px -8% 0px'});
      els.forEach(function(e){if(!e.classList.contains('in'))io.observe(e);});
    } else {
      els.forEach(show);
    }
    // Safety net: never leave in-view content hidden
    window.addEventListener('load',function(){setTimeout(function(){
      els.forEach(function(e){if(!e.classList.contains('in')&&inView(e))show(e);});
    },300);});
  }
  function mobileNav(){
    var panel=document.getElementById('mpanel'),b=document.getElementById('burger'),c=document.getElementById('mclose');
    if(b&&panel)b.addEventListener('click',function(){panel.classList.add('open');});
    if(c&&panel)c.addEventListener('click',function(){panel.classList.remove('open');});
    if(panel)panel.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){panel.classList.remove('open');});});
  }
  function gallery(){
    var main=document.getElementById('pdp-main');
    if(!main)return;
    document.querySelectorAll('.pdp-thumbs img').forEach(function(t){
      t.addEventListener('click',function(){
        main.src=t.getAttribute('data-full')||t.src;
        document.querySelectorAll('.pdp-thumbs img').forEach(function(x){x.classList.remove('active');});
        t.classList.add('active');
      });
    });
  }
  function variants(){
    var root=document.querySelector('[data-product-json]');
    if(!root)return;
    var data;try{data=JSON.parse(root.textContent);}catch(e){return;}
    var sel=document.getElementById('variant-select');
    var idField=document.getElementById('variant-id');
    var priceEl=document.getElementById('pdp-price');
    var btn=document.getElementById('add-btn');
    if(!sel)return;
    function fmt(cents){return 'Rp '+(cents/100).toLocaleString('id-ID');}
    sel.addEventListener('change',function(){
      var v=data.variants.find(function(x){return String(x.id)===sel.value;});
      if(!v)return;
      if(idField)idField.value=v.id;
      if(priceEl)priceEl.textContent=fmt(v.price);
      if(btn){btn.disabled=!v.available;btn.textContent=v.available?('Add to bag — '+fmt(v.price)):'Sold out';}
    });
  }
  function qty(){
    document.querySelectorAll('.qty').forEach(function(q){
      var val=q.querySelector('span'),f=q.querySelector('input.qtyf'),n=1;
      var bs=q.querySelectorAll('button');
      if(bs.length<2)return;
      bs[0].addEventListener('click',function(){n=Math.max(1,n-1);if(val)val.textContent=n;if(f)f.value=n;});
      bs[1].addEventListener('click',function(){n++;if(val)val.textContent=n;if(f)f.value=n;});
    });
  }
  document.addEventListener('DOMContentLoaded',function(){reveal();mobileNav();gallery();variants();qty();});
})();
